import { render, staticRenderFns } from "./QuoteImageCategory.vue?vue&type=template&id=485da12e&scoped=true"
import script from "./QuoteImageCategory.vue?vue&type=script&lang=js"
export * from "./QuoteImageCategory.vue?vue&type=script&lang=js"
import style0 from "./QuoteImageCategory.vue?vue&type=style&index=0&id=485da12e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485da12e",
  null
  
)

export default component.exports